// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"287":"f8a70b84a6668ce1","325":"dfde26caf9afb25b","372":"a229cf7bb83be218"}[chunkId] + ".js";
};